/**
 * The ONE place the browser/server Sentry DSN resolves (instrumentation-client.ts and
 * instrumentation.ts both read it — two resolutions would eventually disagree).
 *
 * COMMITTED FALLBACK, deliberately, on the supabase-config.ts precedent: a DSN is a public
 * ingest identifier that ships inside the browser bundle by design — hiding it in a build
 * variable adds Coolify build-arg friction and zero secrecy. The env var still wins when a
 * deployment needs a different project. Rotate the key in Sentry (Settings → Client Keys)
 * if it is ever abused; nothing here is a credential.
 *
 * Environment tagging keeps local noise separable: NODE_ENV is "development" on dev boxes,
 * so events from `npm run dev` arrive tagged development and are filterable — the DSN being
 * present locally is intended, not an oversight.
 */
const FALLBACK_SENTRY_DSN =
  'https://576bae8e7c4cf1fb27cb66dcda2c275e@o4509567078891520.ingest.us.sentry.io/4511955668238336'

// The fallback applies to PRODUCTION builds only: .env.example promises dev is dark, and a
// committed fallback that fires from `npm run dev` burns quota on data nobody asked to send.
export const SENTRY_DSN = process.env.NEXT_PUBLIC_SENTRY_DISABLED === '1' ? '' :
  process.env.NEXT_PUBLIC_SENTRY_DSN
  || (process.env.NODE_ENV === 'production' ? FALLBACK_SENTRY_DSN : '')
